module.exports = "<div class=\"contact-customer-service bg-color hide\"> <%= consult_agent %> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/q&a/contact/btnTpl.html
// module id = 260
// module chunks = 0